export const isDevelopmentEnvironment = process.env.NODE_ENV === "development";
